import { useState, useCallback } from 'react';

/**
 * Custom hook to manage modal state
 * @returns {Object} Modal state and handlers
 */
export const useModalState = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showVenueLoginModal, setShowVenueLoginModal] = useState(false);
  const [showVenueSignupModal, setShowVenueSignupModal] = useState(false);

  const handleLoginClick = useCallback(() => {
    setShowLoginModal(true);
  }, []);

  const handleSignupClick = useCallback(() => {
    setShowSignupModal(true);
  }, []);

  const closeLoginModal = useCallback(() => {
    setShowLoginModal(false);
  }, []);

  const closeSignupModal = useCallback(() => {
    setShowSignupModal(false);
  }, []);

  const closeVenueLoginModal = useCallback(() => {
    setShowVenueLoginModal(false);
  }, []);

  const closeVenueSignupModal = useCallback(() => {
    setShowVenueSignupModal(false);
  }, []);

  const switchToVenueLogin = useCallback(() => {
    setShowVenueLoginModal(true);
    setShowSignupModal(false);
  }, []);

  const switchToVenueSignup = useCallback(() => {
    setShowVenueSignupModal(true);
    setShowVenueLoginModal(false);
  }, []);

  const switchToSignup = useCallback(() => {
    setShowSignupModal(true);
    setShowLoginModal(false);
  }, []);

  const switchToLogin = useCallback(() => {
    setShowLoginModal(true);
    setShowSignupModal(false);
  }, []);

  return {
    showLoginModal,
    showSignupModal,
    showVenueLoginModal,
    showVenueSignupModal,
    handleLoginClick,
    handleSignupClick,
    closeLoginModal,
    closeSignupModal,
    closeVenueLoginModal,
    closeVenueSignupModal,
    switchToVenueLogin,
    switchToVenueSignup,
    switchToSignup,
    switchToLogin
  };
};

